import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Notification, showNotification } from "react-admin";
import Card from "@material-ui/core/Card";
import Avatar from "@material-ui/core/Avatar";
import LockIcon from "@material-ui/icons/Lock";
import Typography from "@material-ui/core/Typography";
import { Button, TextField } from "@material-ui/core";
import { isStaging } from "../common/utilities";
import tccStyles from "../common/styles";
import myRestClient from "../common/restClient";

const styles = theme => ({
    appLogo: { margin: 20, paddingTop: 20 },
    card: {
        width: 550,
        marginTop: "2em"
    },
    avatar: {
        margin: "1em",
        display: "flex",
        justifyContent: "center"
    },
    icon: {
        backgroundColor: theme.palette.secondary[500],
        marginTop: 20
    },
    button: {
        marginBottom: 10,
        margin: theme.spacing.unit,
        background:
            isStaging() === true
                ? tccStyles.stagingColor.primary
                : tccStyles.productionColor.primary,
        width: "20%",
        color: "white",
        "&:hover": {
            background:
                isStaging() === true
                    ? tccStyles.stagingColor.primary
                    : tccStyles.productionColor.primary
        }
    },
    cssFocused: {},
    cssUnderline: {
        "&:after": {
            borderBottomColor: "black"
        }
    },
    formLabelRoot: {
        "&$formLabelFocused": { color: "grey" }
    },
    formLabelFocused: {}
});

class LoginOffline extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: ""
        };
    }

    handleChange = field => event => {
        this.setState({ [field]: event.target.value });
    };

    handleSubmit = async () => {
        const params = {
            username: this.state.email,
            password: this.state.password,
            auth_type: "TCC_TSID_OFFLINE"
        };
        await myRestClient("LOGIN_OFF", "", params).then(
            response => {
                window.location.href = response.data.redirectUrl;
            },
            err => {
                this.props.dispatch(showNotification(err.message, "warning"));
            }
        );
    };

    render() {
        const { classes } = this.props;

        return (
            <div align="center" className={classes.appLogo}>
                <img
                    src="/static/images/logo_ts.png"
                    alt="Logo"
                    width="100px"
                />
                <span className={classes.appTitle}>
                    <div style={{ marginTop: 20 }}>
                        <Typography component="h2" variant="display1">
                            TeamSystem Cloud Console
                        </Typography>
                    </div>
                </span>
                <Card className={classes.card}>
                    <div className={classes.avatar}>
                        <Avatar className={classes.icon}>
                            <LockIcon />
                        </Avatar>
                    </div>
                    <div style={{ marginTop: 20, marginBottom: 20 }}>
                        <Typography component="h4">
                            Il TeamSystem ID è momentaneamente non disponibile.
                            <br />
                            Se l'hai impostata, puoi accedere con la tua
                            password offline.
                        </Typography>
                    </div>
                    <form
                        noValidate
                        autoComplete="off"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "16px" // Spaziatura tra gli elementi
                        }}
                    >
                        <TextField
                            label="Email"
                            variant="outlined"
                            className={classes.formField}
                            value={this.state.email}
                            style={{ width: "350px" }}
                            onChange={this.handleChange("email")}
                        />
                        <TextField
                            label="Password"
                            type="password"
                            variant="outlined"
                            className={classes.formField}
                            value={this.state.password}
                            style={{ width: "350px" }}
                            onChange={this.handleChange("password")}
                        />
                        <Button
                            color="primary"
                            variant="raised"
                            className={classes.button}
                            onClick={this.handleSubmit}
                        >
                            Login
                        </Button>
                    </form>
                </Card>
                <Notification />
            </div>
        );
    }
}

LoginOffline.propTypes = {
    classes: PropTypes.object.isRequired
};

export default connect()(withStyles(styles)(LoginOffline));



// WEBPACK FOOTER //
// ./src/components/LoginOffline.js